import React from 'react'
import { FormattedMessage } from 'react-intl'

const RetryApi = ({ error, retry }) => {

  return (
    <div className="my-10 flex items-center justify-center flex-col">
      <h2 className="text-medium text-2xl mb-5">
        <FormattedMessage id="error_occured" defaultMessage={"An Error Occured"} />
      </h2>
      <p className="mb-5">
        {error}
      </p>

      <button onClick={retry} className="btn btn-primary w-[200px]">
        <p>
          <FormattedMessage id="retry" defaultMessage={"Retry"} />
        </p>
      </button>
    </div>
  )
}

export default RetryApi